var widget_default = {
  "card": "_76MbG",
  "link": "nyicc",
  "container": "_9Irwi",
  "image": "_1BwPN",
  "right": "_3gmBO",
  "cardLayout": "L536w",
  "content": "Tlaek",
  "title": "dOVWb",
  "subtitle": "tyZmV",
  "button": "HW6-l",
  "button_disabled": "zJp39",
  "buttonText": "Nj-Gx",
  "slimLayout": "_2nJBc",
  "contentText": "N5otY"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
